/**
 * Lifted wrapper for DragOverlay content.
 * Pass the same card/column presentation as children — do not rebuild markup here.
 */

import { cn } from '@/utils/cn';
import {
  KANBAN_CARD_OVERLAY_WIDTH,
  kanbanOverlayLiftClass,
} from './Kanban.styles';
import type { KanbanOverlayProps } from './Kanban.types';

export function KanbanOverlay({
  children,
  width = KANBAN_CARD_OVERLAY_WIDTH,
  className,
}: KanbanOverlayProps) {
  return (
    <div className={cn(kanbanOverlayLiftClass, className)} style={{ width }}>
      {children}
    </div>
  );
}
